































import Vue, { PropType } from 'vue';

import { PeerGroupMember } from '@/models/orgStructure';
import { BasePeerGroup, MemberRole } from '@/models';

import LazyRenderingList from '@/components/LazyRenderingList.vue';
import OrganizationUserCard from '@/components/OrganizationUserCard.vue';

const lookupRoleName = (
  memberRole: MemberRole,
  peerGroup: BasePeerGroup
): string => {
  switch (memberRole) {
    case MemberRole.OBSERVER:
      return MemberRole.OBSERVER;
    case MemberRole.STUDENT:
      return peerGroup.roleNameStudent;
    case MemberRole.TEACHER:
      return peerGroup.roleNameTeacher;
  }
};

export default Vue.extend({
  components: {
    LazyRenderingList,
    OrganizationUserCard
  },

  props: {
    members: {
      type: Array as PropType<PeerGroupMember[]>,
      required: true
    },

    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: true
    }
  },

  data() {
    return {
      rawFilter: '',
      inputFocused: false,
      multiRole: MemberRole.STUDENT
    };
  },

  computed: {
    withFriendlyRoles(): [PeerGroupMember, string][] {
      return this.members.map(m => [
        m,
        lookupRoleName(m.role, this.peerGroup).toUpperCase()
      ]);
    }
  },

  methods: {
    userClick(userId: number) {
      const orgId = this.$route.params['organizationId'] as string;
      this.$router.push({
        name: 'OrganizationUser',
        params: { organizationId: orgId, userId: `${userId}` }
      });
    }
  }
});
